export var RequestHandlerProtocol = /*#__PURE__*/function (RequestHandlerProtocol) {
  RequestHandlerProtocol["HTTP_0_9"] = "http/0.9";
  RequestHandlerProtocol["HTTP_1_0"] = "http/1.0";
  RequestHandlerProtocol["TDS_8_0"] = "tds/8.0";
  return RequestHandlerProtocol;
}(RequestHandlerProtocol || {});